import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import PublicSite from './PublicSite';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <PublicSite />
  </React.StrictMode>
);
